import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import OtherUserGroupMessage from "@/commons/models/OtherUserGroupMessage";
import { HitomeqErrorType } from "@/commons/models/SystemError";
import { AttachedFile } from "./OpinionMessages";

/**
 * 意見メッセージ API 操作クラス
 */
export default class OtherUserOpinionMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET OtherUserOpinionMessages
   */
  public async get(userStore: LoginUser, caseId: number): Promise<Array<OtherUserOpinionMessageGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserOpinionMessages, formatParams);
    const response = await this.commonService.executeGet<Array<OtherUserOpinionMessageGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      {},
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * POST OtherUserOpinionMessages
   */
  public async post(userStore: LoginUser, caseId: number, requestBody: OtherUserOpinionMessagePostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserOpinionMessages, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * PATCH OtherUserOpinionMessages
   */
  public async patch(userStore: LoginUser, caseId: number, opinion: OtherUserGroupMessage): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserOpinionMessages, formatParams);

    // APIのモデルに合わせてここで送信内容を調整
    const requestBody: any = {
      functionType: opinion.functionType,
      functionContents: opinion.functionContents,
      lineId: opinion.lineId,
      messageType: opinion.messageType,
      receiver: opinion.receiver,
      groupId: opinion.groupId,
      groupName: opinion.groupName,
      groupTypeId: opinion.groupTypeId,
      groupMemberId: opinion.groupMemberId,
      groupMemberName: opinion.groupMemberName,
      groupMemberTel: opinion.groupMemberTel,
      groupMemberOrganization: opinion.groupMemberOrganization,
      sender: opinion.sender,
      writtenBy: opinion.writtenBy,
      writerId: opinion.writerId
    };

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
export interface OtherUserOpinionMessageGetModel {
  /** 施設ID */
  facilityId: number;
  /** functionContents */
  functionContents: any;
  /** ケースID */
  otherUserOpinionMessagesCaseId: number;
  /** 施設関係者電話番号 */
  groupMemberTel: string;
  /** 施設関係者所属 */
  groupMemberOrganization: string;
  /** メッセージ内容 */
  content: string;
  /** 送信者 */
  sender: string;
  /** 送信種別() */
  senderType: SendType;
  /** 送信日時 */
  datetime: number;
  /** 受信者 */
  receiver: string;
  /** 添付ファイル */
  attachedFiles: Array<AttachedFile> | null;
  /**  */
  writtenBy: string;
  /**  */
  writerId: string;
}

/** 意見の種類 */
export enum SendType {
  /** 家族 */
  FAMILY = 0,
  /** 施設 */
  FACILITY = 1
}

export interface OtherUserOpinionMessagePostModel {
  /** グループID */
  groupId: number;
  /** メンバーID */
  memberId: number;
  /** 施設関係者電話番号 */
  otherUserGroupMemberTel: string;
  /** 施設関係者所属 */
  otherUserGroupMemberOrganization: string;
  /** コンテンツ */
  content: string;
  /** 送信者ユーザー */
  sender: string;
  /** 受信者ユーザー */
  receiver: string;
  /** 送信種別 */
  senderType: number;
  /** 添付ファイルのS3URL */
  fileUrls: Array<string>;
  /** 添付ファイル名 */
  fileNames: Array<string>;
}
